module.exports = __webpack_public_path__ + "img/cj-user-title.92622c25.png";